import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import doodle from "../assets/img/Doodle.png";
import rooteen from "../assets/img/rooteen.png";
import openup from "../assets/img/openup.png";
import bank from "../assets/img/Bank.png";
import sooki from "../assets/img/sooki.png";
import quik from "../assets/img/QuickEats.png";

// delete

import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { getDropdownMenuPlacement } from "react-bootstrap/esm/DropdownMenu";

export const Projects = () => {

  const projects = [
    {
      title: "What's my doodle",
      description: "Mulitplayer Drawing app where users take turn guessing a players drawing. Created using React, Socket.io and Express.",
      imgUrl: doodle,
      buttonURL:"https://whatsmydoodlee.netlify.app/" ,
    },
    {
      title: "Roo-teen",
      description: "A habit tracker that lets you keep progress of all your daily habits! Created using NodeJs, Docker, Express and PostgreSQL",
      imgUrl: rooteen,
      buttonURL:"https://roo-teen.netlify.app/" ,
    },
    {
      title: "Open Up Blog",
      description: "An anonymous blog where you can share your thoughts and opinions without the fear of being judged. Created using NodeJS, Jest, Express, HTML and CSS ",
      imgUrl: openup,
      buttonURL:"https://openup-fp.netlify.app/" ,
    },
    {
      title: "Bank Of Alerica",
      description: "Simple banking app made using Java and Spring Boot.",
      imgUrl: bank,
      buttonURL:"https://springdemo96.herokuapp.com/" ,
    },
  
    {
      title: "Sooki",
      description: "A meal planner that plans meals for users whilst helping them stick to their budget! This projected was created using ReactJS, Django, Javascript and Postrgres ",
      imgUrl: sooki,
      buttonURL:"https://digerati-meal-planner.netlify.app/" ,
    },
    {
      title: "QuikEats",
      description: "An android application that allows you to order items at a restaurant through the use of barcodes. Created using Java, Android Studio and Barcode Reader.",
      imgUrl: quik,
      buttonURL:"https://github.com/alihamedali96/QuikEats" ,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                   
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
